import { Badge, Group, Stack, Text } from "@mantine/core";
import { type FragmentOf, graphql, readFragment } from "gql.tada";

export const TournamentsStepGeneratedFragment = graphql(`
  fragment TournamentsStepGeneratedFields on TournamentsStepGeneratedPayload {
    __typename
    stepId
    ruleSetId
    groupCount
    gameCount
    seededTeamCount
    engineTimingMs
  }
`);

interface Props {
  data: FragmentOf<typeof TournamentsStepGeneratedFragment>;
}

export function TournamentsStepGeneratedPayload({ data }: Props) {
  const p = readFragment(TournamentsStepGeneratedFragment, data);
  return (
    <Stack gap={4}>
      <Group gap="xs" wrap="wrap">
        <Badge color="green" size="xs">
          STEP GENERATED
        </Badge>
        <Text size="xs">
          step {p.stepId.slice(0, 8)} · rule set {p.ruleSetId.slice(0, 8)}
        </Text>
      </Group>
      <Text size="xs" c="dimmed">
        {p.groupCount} group{p.groupCount === 1 ? "" : "s"} · {p.gameCount} game
        {p.gameCount === 1 ? "" : "s"} · {p.seededTeamCount} team
        {p.seededTeamCount === 1 ? "" : "s"} seeded
      </Text>
      <Text size="xs" c="dimmed">
        timing: {p.engineTimingMs.toFixed(2)}ms
      </Text>
    </Stack>
  );
}
